var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.412 8l5.297-5.296a1.002 1.002 0 000-1.413 1.002 1.002 0 00-1.413 0L8 6.588 2.704 1.29a1.002 1.002 0 00-1.413 0 1.002 1.002 0 000 1.413L6.588 8 1.29 13.296a1.002 1.002 0 000 1.413 1.002 1.002 0 001.413 0L8 9.412l5.296 5.297a1.002 1.002 0 001.413 0 1.002 1.002 0 000-1.413L9.412 8z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.c990af96b2cf9c1b8e0f296d4b16855c.svg";
export { ForwardRef as ReactComponent };